import React, { Fragment, useState, useEffect, useCallback } from "react";
import "../MapStyle.css";
import { ResourceComponentProps, Title, useVersion } from "react-admin";
import { GoogleMap } from "../GoogleMap";
import { GoogleMapMarker } from "../GoogleMapMarker";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import {
  LocationApiFactory,
  TrailerGpsLocationDto,
} from "../../../common/data/service-proxies";
import { AppBarSimpleSearchField } from "../../common/data-grid-inputs/AppBarSimpleSearchField";
import { useGetDistanceFromBottom } from "../common/useGetDistanceFromBottom";

interface Props extends ResourceComponentProps {}

export const TrailerLocationsView = (props: Props) => {
  const [loading, setLoading] = useState<boolean>();
  const [error, setError] = useState<string>();
  const [data, setData] = useState<Array<TrailerGpsLocationDto>>();
  const [searchText, setSearchText] = useState<string>("");
  const axiosInstance = useAxiosInstance();
  const version = useVersion();

  const { handleMapBoundsChanged } = useGetDistanceFromBottom();

  const shouldHideMarker = useCallback(
    (location: TrailerGpsLocationDto) => {
      let isInGroup = true;
      return (
        !isInGroup ||
        (searchText.length > 0 &&
          !!location.name &&
          !location.name.includes(searchText))
      );
    },
    [searchText]
  );

  useEffect(() => {
    if (!axiosInstance) {
      return;
    }

    setLoading(true);
    setError(undefined);
    LocationApiFactory(
      undefined,
      axiosInstance?.defaults.baseURL,
      axiosInstance
    )
      .apiAppTrailerLocationsGet()
      .then((response) => {
        setData(response.data);
      })
      .catch((e) => {
        if (e.message) {
          setError(e.message);
          return;
        }

        setError(JSON.stringify(e));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [axiosInstance, version]);

  const handleSearchTextChange = (text: string) => {
    setSearchText(text);
  };

  if (!loading && !error && !data) {
    return null;
  }

  return (
    <Fragment>
      <Title title={"resources.locations-trailers.name"} />
      <AppBarSimpleSearchField onSearchTextChange={handleSearchTextChange} />
      <GoogleMap
        loading={loading}
        error={error}
        onBoundsChanged={handleMapBoundsChanged}
      >
        {!!data
          ? data.map((loc) => {
              if (!loc.lat || !loc.lng || !loc.name) {
                return null;
              }

              return (
                <GoogleMapMarker
                  hide={shouldHideMarker(loc)}
                  key={loc.id}
                  lat={loc.lat}
                  lng={loc.lng}
                  bearing={0}
                  vehicleName={loc.name}
                  iconPath="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                />
              );
            })
          : null}
      </GoogleMap>
    </Fragment>
  );
};
